import { PageHero } from "../components/site/Layout";
import { ContactCards } from "./Contact";
import { OrderingSections } from "./Ordering";

export default function ContactOrdering() {
  return (
    <>
      <PageHero eyebrow="Contact & ordering" title="Let's" script="chat" testid="contact-ordering-hero">
        Questions, ideas or quick quotes: we'd love to hear from you. Below you'll find how ordering works and the ways you can pay.
      </PageHero>
      <ContactCards />
      <OrderingSections />
    </>
  );
}
